import { useState, useEffect } from 'react';

const Timer = ({ initTime, seconds = 30, className = '', renderChildren}) => {
    const [timer, setTimer] = useState<number>(0);
    
    function startTimer(){
        if(Date.now() - initTime < (seconds * 1000)) {
            setTimer(Math.ceil((initTime + (seconds * 1000) - Date.now())/1000))
        } else {
            setTimer(0);
        }
    }

    useEffect(() => {
        startTimer();
    }, [initTime])

    useEffect(() => {
        const timer = setTimeout(() => {
            startTimer();
        }, 1000);
        return () => clearTimeout(timer);
    }, [timer])

    return (
        <div className={className}>
            {
                renderChildren(timer)
            }
        </div>
    );
};

export default Timer;
